import React from 'react';
import { Col, Row } from 'reactstrap';

const Loader = props => (
  <Row className="flex-center py-5">
    <Col xs="auto">
      <div className="spinner-border" {...props} />
    </Col>
  </Row>
);

//Loader.propTypes = { ...Spinner.propTypes };

Loader.defaultProps = {
  type: 'grow',
  size: 'lg',
  color: 'primary'
};

export default Loader;
